
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BooksHero from './components/BooksHero';
import BooksList from './components/BooksList';

const BooksPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <BooksHero />
        <BooksList />
      </motion.main>

      <Footer />
    </div>
  );
};

export default BooksPage;
